module.exports = __webpack_public_path__ + "static/img/pop_bg@2x.ae2e5e11.png";